import Hero from "./Hero";
import Timeline from "./Timeline";
import University from "./University";
import Reasons from "./Reasons";
import Clip from "./Clip";
import ISO from "./ISO";
import Team from "./Team";
import Life from "./Life";
import wrapperClasses from "../../components/commons/Wrapper.module.scss";
import classes from "./index.module.scss";

export default function AboutUs() {
  return (
    <section className={`${wrapperClasses.section} ${classes.section}`}>
      <Hero />
      <Timeline />
      <University />
      <Reasons />
      <Clip />
      <Life />
      <Team />
      <ISO />
    </section>
  );
}
